jQuery(document).ready(function ($) {

    // Hero Swiper
    var swiper = new Swiper('.hero-swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        speed: 1500,
        allowTouchMove: false,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
    });

    // Big Swiper
    var swiper = new Swiper('.swiper-container.big-swiper', {
        observer: true,
        observeParents: true,
        autoplay: {
            delay: 7000,
        },
        speed: 700,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        pagination: {
            el: '.big-swiper .swiper-pagination',
        },
    });

    // Grid Swiper
    var swiper = new Swiper('.swiper-container.grid-swiper', {
        observer: true,
        observeParents: true,
        slidesPerView: 'auto',
        speed: 500,
        preloadImages: false,
        lazy: {
            loadPrevNext: true,
        },
        pagination: {
            el: '.grid-swiper .swiper-pagination',
        },
    });

});
